// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".font-title{font-size:1.25rem!important;font-weight:500;letter-spacing:.0125em!important;line-height:2rem}.font-subhead-1{font-size:1rem!important;font-weight:400;letter-spacing:.009375em!important;line-height:1.75rem}.font-body-2{font-size:.875rem!important;letter-spacing:.0178571429em!important}.font-body-2,.font-caption{font-weight:400;line-height:1.25rem}.font-caption{font-size:.75rem!important;letter-spacing:.0125em!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
